import { useState } from 'react';
import LeadCaptureForm from '@/components/LeadCaptureForm';

const custosNaoResolver = [
  { icon: 'ri-money-dollar-circle-line', text: 'Perda constante de dinheiro sem perceber' },
  { icon: 'ri-lock-line', text: 'Crescimento travado por falta de estrutura' },
  { icon: 'ri-mental-health-line', text: 'Desgaste físico e mental do empresário' },
  { icon: 'ri-question-mark', text: 'Falta de previsibilidade no negócio' },
];

const ofertaItens = [
  '8 sessões presenciais + 8 sessões online em 60 dias',
  'Diagnóstico empresarial completo',
  'Organização da gestão e processos',
  'Estrutura financeira com controle real',
  'Estrutura comercial e funil de vendas',
  'Plano de crescimento e inovação',
  'Implementação de ferramentas de IA',
];

export default function DiferencialOfertaSection() {
  const [mostrarForm, setMostrarForm] = useState(false);

  return (
    <>
      {/* Diferencial */}
      <section className="py-24 md:py-32 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-16">
            <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
              Por que somos diferentes
            </p>
            <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight">
              NÃO É MAIS UMA<br />
              <span className="text-amber-500">CONSULTORIA TEÓRICA</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20">
            {/* Consultorias tradicionais */}
            <div className="bg-white rounded-3xl p-8 md:p-10 border border-stone-100">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-xl">
                  <i className="ri-close-circle-line text-red-500 text-xl" />
                </div>
                <h3 className="text-lg font-black text-gray-900">Consultorias Tradicionais</h3>
              </div>
              <ul className="space-y-4">
                {[
                  'Foco em teoria e apresentações',
                  'Diagnósticos superficiais',
                  'Pouca ou nenhuma implementação',
                  'Você recebe um relatório e fica sozinho',
                  'Resultado incerto e demorado',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-close-line text-red-400 text-base mt-0.5 shrink-0" />
                    <span className="text-gray-500 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Transformação Real */}
            <div className="bg-gray-900 rounded-3xl p-8 md:p-10">
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-400/20 rounded-xl">
                  <i className="ri-check-double-line text-amber-400 text-xl" />
                </div>
                <h3 className="text-lg font-black text-white">Transformação Real 60D</h3>
              </div>
              <ul className="space-y-4">
                {[
                  'Execução prática desde o primeiro dia',
                  'Aplicação direta no seu negócio',
                  'Acompanhamento intensivo presencial',
                  'Você sai de cada sessão com ações implementadas',
                  'Foco total em resultado mensurável',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-400 text-base mt-0.5 shrink-0" />
                    <span className="text-white/80 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Custo de não resolver */}
          <div className="bg-red-950 rounded-3xl p-8 md:p-12">
            <div className="text-center mb-10">
              <p className="text-red-400 text-xs font-bold uppercase tracking-widest mb-3">Atenção</p>
              <h3 className="text-3xl md:text-4xl font-black text-white leading-tight">
                O CUSTO DE NÃO RESOLVER
              </h3>
              <p className="text-white/50 text-base mt-3">Continuar sem estrutura gera:</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {custosNaoResolver.map((c) => (
                <div key={c.text} className="bg-red-900/40 border border-red-800/30 rounded-2xl p-5 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-800/40 rounded-xl mx-auto mb-4">
                    <i className={`${c.icon} text-red-400 text-xl`} />
                  </div>
                  <p className="text-white/70 text-sm leading-relaxed">{c.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Oferta + Investimento */}
      <section id="oferta" className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-12 items-center">
            {/* Left — O que está incluso */}
            <div>
              <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
                A oferta completa
              </p>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
                TUDO QUE VOCÊ<br />
                <span className="text-amber-500">RECEBE NO PROGRAMA</span>
              </h2>
              <p className="text-gray-500 text-base leading-relaxed mb-8 md:mb-10">
                Um programa intensivo completo para estruturar sua empresa em 60 dias, com acompanhamento presencial e aplicação direta no negócio.
              </p>
              <ul className="space-y-3 md:space-y-4">
                {ofertaItens.map((item) => (
                  <li key={item} className="flex items-center gap-3 md:gap-4">
                    <span className="w-6 h-6 flex items-center justify-center bg-amber-400 rounded-full shrink-0">
                      <i className="ri-check-line text-gray-900 text-xs font-bold" />
                    </span>
                    <span className="text-gray-700 text-sm font-medium">{item}</span>
                  </li>
                ))}
              </ul>

              {/* Bônus Jurídico */}
              <div className="mt-6 relative rounded-2xl p-[2px]"
                style={{ background: 'linear-gradient(135deg, #f59e0b, #a5b4fc, #f59e0b)' }}>
                <div className="rounded-2xl bg-amber-50 px-5 py-4 flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-100 border border-amber-300 rounded-xl shrink-0">
                    <i className="ri-scales-3-line text-amber-600 text-lg" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <span className="text-gray-900 text-sm font-bold">Proteção Jurídica para Empresas</span>
                      <span className="inline-flex items-center gap-1 bg-amber-400/30 border border-amber-400/50 text-amber-700 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-widest whitespace-nowrap">
                        <i className="ri-gift-line text-[10px]" /> Bônus
                      </span>
                    </div>
                    <p className="text-gray-500 text-xs leading-relaxed">Contratos padronizados, documentos organizados e estrutura jurídica para blindar seu negócio.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right — Sob consulta */}
            <div className="bg-gray-900 rounded-3xl p-6 md:p-8 lg:p-12 text-center">
              {!mostrarForm ? (
                <>
                  <p className="text-white/40 text-xs font-bold uppercase tracking-widest mb-6">A decisão está com você!</p>

                  <div className="mb-6 md:mb-8">
                    <p className="text-amber-400 text-xl sm:text-2xl font-black mb-3 leading-tight">Faça parte do próximo grupo de negócios que vão evoluir em 60 dias</p>
                    <p className="text-white/50 text-sm leading-relaxed">Vagas limitadas</p>
                  </div>

                  <div className="grid grid-cols-2 gap-3 md:gap-4 mb-8 md:mb-10">
                    <div className="bg-white/5 border border-white/10 rounded-2xl p-4 md:p-5">
                      <i className="ri-user-settings-line text-amber-400 text-xl md:text-2xl mb-2 md:mb-3" />
                      <p className="text-white font-bold text-sm mb-1">Mentoria Presencial</p>
                      <p className="text-white/50 text-xs">Acompanhamento individual</p>
                    </div>
                    <div className="bg-amber-400/10 border border-amber-400/20 rounded-2xl p-4 md:p-5">
                      <i className="ri-rocket-line text-amber-400 text-xl md:text-2xl mb-2 md:mb-3" />
                      <p className="text-white font-bold text-sm mb-1">Resultado 60 Dias</p>
                      <p className="text-amber-400 text-xs font-semibold">Transformação real</p>
                    </div>
                  </div>

                  {/* Escassez */}
                  <div className="bg-red-950/60 border border-red-800/30 rounded-2xl p-4 md:p-5 mb-6 md:mb-8">
                    <div className="flex items-center justify-center gap-2 mb-2">
                      <i className="ri-alarm-warning-line text-red-400 text-base" />
                      <span className="text-red-400 text-xs font-bold uppercase tracking-widest">Vagas Limitadas</span>
                    </div>
                    <p className="text-white/60 text-xs leading-relaxed">
                      Para garantir acompanhamento próximo e resultados reais, aceitamos um número limitado de empresas por ciclo.
                    </p>
                  </div>

                  <button
                    onClick={() => setMostrarForm(true)}
                    className="whitespace-nowrap w-full bg-amber-400 hover:bg-amber-300 text-gray-900 font-black text-sm py-4 rounded-xl transition-all cursor-pointer flex items-center justify-center gap-2"
                  >
                    TENHO INTERESSE E QUERO SABER MAIS!
                    <i className="ri-arrow-right-line" />
                  </button>
                  <p className="text-white/30 text-xs mt-4">Sem compromisso · Resposta em até 24h</p>
                </>
              ) : (
                <div className="text-left">
                  <div className="flex items-center justify-between mb-6">
                    <p className="text-white/40 text-xs font-bold uppercase tracking-widest">Preencha seus dados</p>
                    <button onClick={() => setMostrarForm(false)} className="text-white/30 hover:text-white/60 cursor-pointer">
                      <i className="ri-close-line text-lg" />
                    </button>
                  </div>
                  <LeadCaptureForm variant="dark" />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}